import React, { useEffect, useState } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Container, Btn } from '../components/ui';
import Seo from '../components/Seo';
import { articleJsonLd, breadcrumbJsonLd } from '../data/seo';
import SocialShare from '../components/SocialShare';
import CTASection from '../components/CTASection';
import { CaseStudyArticle } from '../components/ArticleView';
import { fetchCaseStudy, trackContent, resolveImg } from '../lib/marketingApi';

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const { t } = useLanguage();
  const [cs, setCs] = useState(undefined);

  useEffect(() => {
    setCs(undefined);
    fetchCaseStudy(slug).then((d) => setCs(d.item)).catch(() => setCs(null));
  }, [slug]);

  useEffect(() => {
    if (cs && cs.slug) {
      const key = `bpv:cs:${cs.slug}`;
      if (!sessionStorage.getItem(key)) { trackContent('case_study', cs.slug, 'view'); sessionStorage.setItem(key, '1'); }
    }
  }, [cs]);

  if (cs === undefined) {
    return <div className="flex items-center justify-center py-40 text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  }
  if (cs === null) return <Navigate to="/case-studies" replace />;

  return (
    <div>
      <Seo
        title={cs.seo?.meta_title || cs.title}
        description={cs.seo?.meta_description || cs.excerpt}
        keywords={cs.seo?.keywords}
        path={`/case-studies/${cs.slug}`}
        type="article"
        image={cs.image ? resolveImg(cs.image) : undefined}
        jsonLd={[
          articleJsonLd({ title: cs.title, description: cs.excerpt, image: cs.image ? resolveImg(cs.image) : undefined, path: `/case-studies/${cs.slug}`, datePublished: cs.published_at || cs.created_at, dateModified: cs.updated_at }),
          breadcrumbJsonLd([{ name: 'Case Studies', path: '/case-studies' }, { name: cs.title, path: `/case-studies/${cs.slug}` }]),
        ]}
      />
      <div className="bg-brand-ink px-5 pt-8 sm:px-8">
        <Container>
          <Link to="/case-studies" className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-300 hover:text-white"><ArrowLeft className="h-4 w-4" /> {t('common.allCaseStudies')}</Link>
        </Container>
      </div>

      <CaseStudyArticle cs={cs} />

      <section className="px-5 pb-16 sm:px-8">
        <Container className="max-w-3xl">
          <div className="flex flex-col items-start justify-between gap-4 border-t border-slate-200 pt-6 dark:border-white/10 sm:flex-row sm:items-center">
            <span onClick={() => trackContent('case_study', slug, 'share_click')}><SocialShare title={cs.title} summary={cs.excerpt} /></span>
            <span onClick={() => trackContent('case_study', slug, 'cta_click')} data-testid="article-cta-demo"><Btn to="/demo" arrow>{t('common.requestDemo')}</Btn></span>
          </div>
        </Container>
      </section>

      <CTASection />
    </div>
  );
}
